import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LegalBody } from "./Terms";
import { PRIVACY_CONTENT } from "./legal-content";
import usePageMeta from "../hooks/usePageMeta";

export default function Privacy() {
  usePageMeta({
    title: "Privacy Policy — AiPresidential",
    description: "Privacy Policy for AiPresidential.com. Email collection, third-party services, and your rights.",
    path: "/privacy",
  });
  return (
    <div className="min-h-screen bg-[var(--void)] text-gray-200">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 mb-8 text-sm font-orbitron tracking-widest uppercase"
          data-testid="privacy-back-home"
        >
          <ArrowLeft className="w-4 h-4" /> Back Home
        </Link>
        <h1 className="font-orbitron text-4xl md:text-5xl font-bold gradient-text mb-8" data-testid="privacy-title">
          Privacy Policy
        </h1>
        <LegalBody content={PRIVACY_CONTENT} testidPrefix="privacy" />
      </div>
    </div>
  );
}
